import React from 'react'
import styles from "./growthPlan.module.css"
import {ReactComponent as RupeeSvg} from "../../../images/paymentPlan/rupeeWhite.svg"
import plansRightCheckSvg from "../../../images/paymentPlan/plansRightCheck1.jpg";
import { GrowthPlanData } from '../../../data/PaymentPlan/GrowthPlan';

const GrowthPlan = () => {
    return (
        <div className ={styles.basicPlancontainer} >
            <div className={styles.PlanNameContainer}>
                <p className={styles.PlanName} > Growth</p>
            </div>
            <div className={styles.pricingContainer} >
                <p className={styles.pricingdetails} > Perfect to jumpstart your journey on WhatsApp </p>
                <div className='d-flex align-items-center  gap-1' >
                    {/* <img src={rupeeSvg} alt='rupee' className={styles.rupee} /> */}
                    <RupeeSvg className={styles.rupee}  />
                    <p className={styles.amount} > 4,999/-</p>
                </div>
                <p className={styles.pricingdetails} style={{fontWeight:800}} >( Single Pack ) <br/> <span style={{fontWeight:800, fontSize:"0.7rem"}} > validity one year  </span>  </p>
            </div>
            <div className={styles.conversationContainer} >
                <p className={styles.conversation} > 5000 Conversations</p>
                {/* <p className={styles.rechargeText}> When conversation credits run out, they can be recharged at different prices.</p> */}
            </div>
            <div  className='d-flex justify-content-center'style={{marginTop:"3px"}} >
                <div style={{background:"#D9D9D9", width:"85%", height:"1px"}} ></div>
            </div>
            <div className={styles.serviceContainer} >
                <p className={`${styles.services} my-1 `} >Services Included</p>
                {GrowthPlanData.map((data,index)=>(
                    <div className='d-flex align-items-start gap-2 my-2 ' key={index} >
                    <img src={plansRightCheckSvg} alt='plans' title='rightCheck'  className={styles.plansCheck}  />
                    <p className={styles.servicesListItem} >{data}</p>
                </div>
                ))}
               
            </div>
        </div>
      )
}

export default GrowthPlan